import { render, staticRenderFns } from "./bulk-update.vue?vue&type=template&id=617d3beb"
import script from "./bulk-update.vue?vue&type=script&lang=js"
export * from "./bulk-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports